export default __webpack_public_path__ + "static/media/healthcare.1ecaf364.png";